import React, { useState } from 'react';

const Pressable = ({ 
  style, 
  children, 
  onPress, 
  onPressIn, 
  onPressOut,
  disabled,
  ...props 
}) => {
  const [isPressed, setIsPressed] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  
  const convertStyle = (rnStyle) => {
    // Start with defaults
    const defaults = { display: 'flex', flexDirection: 'column', cursor: disabled ? 'not-allowed' : 'pointer' };
    
    if (!rnStyle) return defaults;
    
    const cssStyle = { ...defaults, ...rnStyle };
    
    // Handle flex shorthand
    if (typeof cssStyle.flex === 'number') {
      cssStyle.flexGrow = cssStyle.flex;
      cssStyle.flexShrink = 1;
      cssStyle.flexBasis = '0%';
      delete cssStyle.flex;
    }
    
    // Ensure cursor is always set based on disabled state
    cssStyle.cursor = disabled ? 'not-allowed' : 'pointer';
    return cssStyle;
  };
  
  const getStyle = () => {
    let currentStyle = style;
    
    if (typeof style === 'function') {
      currentStyle = style({ pressed: isPressed, hovered: isHovered });
    }
    
    // Merge array styles first, then convert
    const mergedStyle = Array.isArray(currentStyle) 
      ? currentStyle.reduce((acc, s) => ({ ...acc, ...s }), {})
      : currentStyle;
      
    return convertStyle(mergedStyle);
  };
  
  const handleMouseDown = (e) => {
    if (disabled) return;
    setIsPressed(true);
    onPressIn?.(e);
  };
  
  const handleMouseUp = (e) => {
    if (disabled) return;
    setIsPressed(false);
    onPressOut?.(e);
  };
  
  const handleClick = (e) => {
    if (disabled) return;
    onPress?.(e);
  };
  
  return (
    <div
      style={getStyle()}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      onMouseLeave={() => { setIsPressed(false); setIsHovered(false); }}
      onMouseEnter={() => setIsHovered(true)}
      onClick={handleClick}
      {...props}
    >
      {typeof children === 'function' 
        ? children({ pressed: isPressed, hovered: isHovered })
        : children
      }
    </div>
  );
};

export default Pressable;